import { render, staticRenderFns } from "./ExportClientsHotsite.vue?vue&type=template&id=15278e0c"
import script from "./ExportClientsHotsite.vue?vue&type=script&lang=js"
export * from "./ExportClientsHotsite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports